
interface IProps {
    children?: any,
}

export const WebsiteTable = (props: IProps) => {

    return (
        <div className="table-responsive">
            <table className="table table-centered">
                <thead className="thead-light">
                    <tr>
                        <th>Založeno</th>

                        <th></th>

                        <th>Skupina</th>

                        <th>Jazyk</th>

                        <th></th>

                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {props.children}
                </tbody>
            </table>
        </div>)
}